import React from "react";

import CheckIcon from "@uui/CheckCircle";
import XIcon from "@uui/XCircle";

import { Button, Typography } from "@mui/material";

import FeatureListItem from "@app/analytics/components/FeatureListItem";
import Link from "@app/common/components/Link";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";

import Stack, { Row } from "@rui/Stack";
import { Span } from "@rui/styles";

const PlanName = ({
  name,
  supported,
}: {
  name: string;
  supported?: boolean;
}) => {
  return (
    <Row alignItems="center">
      {supported ? (
        <CheckIcon sx={{ color: "shades.meadow.500", height: "16px" }} />
      ) : (
        <XIcon sx={{ color: "shades.negative.500", height: "16px" }} />
      )}
      <Typography variant="bodyPrimaryReg">{name}</Typography>
    </Row>
  );
};

const WorkspaceOverviewUpsell = () => {
  return (
    <Stack
      sx={{
        width: "100%",
        maxWidth: "750px",
        padding: "40px",
        margin: "40px auto",
      }}
      spacing="24px"
    >
      <Typography variant="h2">
        Your{" "}
        <Span sx={{ color: "shades.primary.500", display: "inline" }}>
          Free plan
        </Span>{" "}
        doesn't support Team and Organization reporting for Workspaces.
      </Typography>
      <Row
        spacing="24px"
        sx={{
          width: "100%",
          backgroundColor: "shades.primary.50",
          borderRadius: "8px",
          padding: "16px",
        }}
      >
        <Typography sx={{ color: "shades.neutral.500" }}>
          This feature is supported in:
        </Typography>
        <PlanName name="Free plan" />
        <PlanName name="Pro plan" supported />
        <PlanName name="Enterprise plan" supported />
      </Row>
      <Stack spacing={1}>
        <Typography>
          When you upgrade to a paid plan, you get all of your Free Plan, plus:
        </Typography>
        <FeatureListItem>Unlimited meetings measured</FeatureListItem>
        <FeatureListItem>Admin Controls + User Permissions</FeatureListItem>
        <FeatureListItem>
          Team and Organizational Reports and Recommendations
        </FeatureListItem>
        <Typography>...And much more!</Typography>
      </Stack>
      <Row sx={{ height: "46px" }} spacing={2}>
        <Button
          component={Link}
          variant="contained"
          sx={{ padding: "0 24px" }}
          to={ROUTES.UPGRADE_ACCOUNT}
        >
          Upgrade Plan
        </Button>
        <Button
          component={Link}
          variant="outlined"
          sx={{ padding: "0 24px" }}
          href={LINKS.MARKETING.PLANS_PRICING}
        >
          Compare Plans
        </Button>
      </Row>
      <Typography variant="body1" sx={{ color: "shades.neutral.500" }}>
        Want to learn more about Read pricing? Contact{" "}
        <Link href={LINKS.EMAIL.SALES}>sales@read.ai</Link>.
      </Typography>
    </Stack>
  );
};

export default WorkspaceOverviewUpsell;
